var _Circle, _Circle2, _Circle3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import Svg, { Circle } from "react-native-svg";
var SvgMoreHorizontal = function SvgMoreHorizontal(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "feather feather-more-horizontal"
  }, props), _Circle || (_Circle = /*#__PURE__*/React.createElement(Circle, {
    cx: 12,
    cy: 12,
    r: 1
  })), _Circle2 || (_Circle2 = /*#__PURE__*/React.createElement(Circle, {
    cx: 19,
    cy: 12,
    r: 1
  })), _Circle3 || (_Circle3 = /*#__PURE__*/React.createElement(Circle, {
    cx: 5,
    cy: 12,
    r: 1
  })));
};
export default SvgMoreHorizontal;